import { FC } from "react";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { ButtonUI } from "src/app/ui/buttons/button.ui";
import { FormComponent } from "src/app/pages/creative-intelligence-suite/pages/business-settings/pages/account-and-brands/pages/account/pages/edit-business/edit-business.form.page";
import { useUsersDomain } from "src/domain/users/users.domain";
import { useRequestFeature } from "src/app/features/requests/request.feature";
import { FormErrorsWidget } from "src/app/pages/signup/form-errors.widget";
import toast from "react-hot-toast";

export const EditPasswordFormPage: FC<FormComponent> = ({ defaultValues }) => {
  const { updateUser } = useUsersDomain();
  const { sendRequest, isLoading } = useRequestFeature();

  const { register, handleSubmit, formState, watch, reset } = useForm({
    defaultValues,
  });

  const newPassword = watch("newPassword");

  const passwordMatchValidator = (value: any) => {
    if (value !== newPassword) {
      return "Password doesn't match";
    }
    return true;
  };

  const submitHandler: SubmitHandler<FieldValues> = async ({
    currentPassword,
    newPassword,
  }) => {
    sendRequest({
      id: "updating-user",
      request: updateUser({
        currentPassword,
        newPassword,
      }),
      onSuccess() {
        toast.success("User password updated");
        reset();
      },
    }).then();
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <div className="flex w-full flex-col gap-4">
        <label
          style={{
            display: "flex",
            flexDirection: "column",
          }}
          htmlFor="currentPassword"
        >
          <div className="pb-2">Current password*</div>
          <input
            id="currentPassword"
            {...register("currentPassword", {
              required: "Current password is required",
            })}
            type="password"
          />
        </label>

        <label
          style={{
            display: "flex",
            flexDirection: "column",
          }}
          htmlFor="newPassword"
        >
          <div className="pb-2">New password*</div>
          <input
            id="newPassword"
            {...register("newPassword", {
              required: "New password is required",
            })}
            type="password"
          />
        </label>

        <label
          style={{
            display: "flex",
            flexDirection: "column",
          }}
          htmlFor="confirmNewPassword"
        >
          <div className="pb-2">Confirm new password*</div>
          <input
            id="confirmNewPassword"
            {...register("confirmNewPassword", {
              required: "Confirm new password is required",
              validate: passwordMatchValidator,
            })}
            type="password"
          />
        </label>
      </div>

      <div className="h-3"></div>
      <FormErrorsWidget formState={formState} />
      <div className="h-3"></div>

      <div className="flex items-center justify-end gap-2">
        <ButtonUI
          isLoading={isLoading("updating-user")}
          onClick={handleSubmit(submitHandler)}
        >
          Update password
        </ButtonUI>
      </div>
    </form>
  );
};
